import { render, staticRenderFns } from "./ChallengeModal.vue?vue&type=template&id=4944b7a8&scoped=true&"
import script from "./ChallengeModal.vue?vue&type=script&lang=js&"
export * from "./ChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeModal.vue?vue&type=style&index=0&id=4944b7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4944b7a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardActions,VCardText,VContainer,VDialog})
